<template>
  <div class="geek-lp">
    <img @click="toLP" src="@/assets/Geek.png" />
    <div class="__exp">
      <div class="__1">無料説明会</div>
      <div class="__2">こちらから！</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toLP: function() {
      const url = "https://geek-salon.com/"
      window.open(url, "_blank")
    },
  },
}
</script>

<style lang="scss" scoped>
.geek-lp {
  width: 100px;
  background-color: #765f36;
  position: fixed;
  right: 0px;
  bottom: 0px;
  padding-top: 38px;
  padding-bottom: 37px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  img {
    height: 60px;
    width: 60px;
    margin-bottom: 15px;
    cursor: pointer;
  }
  .__exp {
    font-family: sans-serif;
    color: #ffffff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .__1 {
      font-size: 0.9rem;
      font-weight: bold;
    }
    .__2 {
      font-size: 0.7rem;
    }
  }
}
</style>
